/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import WebsiteAnnouncementsManagementDash from "../../components/WebsiteAnnouncementsManagement";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const WebsiteAnnouncementManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.websiteAnnouncements?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <WebsiteAnnouncementsManagementDash userConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default WebsiteAnnouncementManagement;
